import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reshipInProgress: {
    defaultMessage: 'Reship in progress...',
    description: 'Notification to user that reship is in progress',
    id: '8TzQL3',
  },
  reshipSuccessNotificationTitle: {
    defaultMessage: 'Shipments Successfully Moved to Awaiting Shipment',
    description: 'Title for a notification to user that reship was successful',
    id: 'k2xBAa',
  },
  reshipSuccessNotificationContent: {
    defaultMessage: 'Review the shipping configuration to re-process and reship the shipment.',
    description: 'Content for a notification to user that reship was successful',
    id: 'pSrnde',
  },
  reshipFailureNotificationTitle: {
    defaultMessage: 'Reship Failed',
    description: 'Title for a notification to user that reship failed',
    id: 'aPJbXM',
  },
  reshipFailureNotificationContent: {
    defaultMessage: 'Please try again.',
    description: 'Content for a notification to user that reship failed',
    id: '5S5JH5',
  },
});
